export default "__VITE_ASSET__Bcg4ywf0__"